import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AddressRequestDto } from "../dto/request/address-request-dto.interface";
import { AddressResponseDto } from "../dto/response/address-response-dto.interface";

@Injectable({
  providedIn: "root"})
export class AddressService {
  constructor(private _httpClient: HttpClient) {}

  getAddresses(profileId: string): Observable<AddressResponseDto[]> {
    return this._httpClient.get<AddressResponseDto[]>(
      `${environment.backend}/address?profileId=${profileId}`
    );
  }

  createAddress(request: AddressRequestDto): Observable<AddressResponseDto> {
    return this._httpClient.post<AddressResponseDto>(
      `${environment.backend}/address`,
      request
    );
  }

  updateAddress(
    addressId: string,
    request: AddressRequestDto
  ): Observable<AddressResponseDto> {
    return this._httpClient.patch<AddressResponseDto>(
      `${environment.backend}/address/${addressId}`,
      request
    );
  }

  deleteAddress(addressId: string): Observable<void> {
    return this._httpClient.delete<void>(
      `${environment.backend}/address/${addressId}`
    );
  }
}
